import { render, staticRenderFns } from "./systemNotice.vue?vue&type=template&id=c0dac468&scoped=true&"
import script from "./systemNotice.vue?vue&type=script&lang=js&"
export * from "./systemNotice.vue?vue&type=script&lang=js&"
import style0 from "./systemNotice.vue?vue&type=style&index=0&id=c0dac468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dac468",
  null
  
)

export default component.exports